/* Copyright (c) 2021-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { DiscoveryRule } from "~/generated/graphql";

export enum ACTION {
  ADD = "add",
  UPDATE = "update",
  REMOVE = "remove",
}

export type RuleData = {
  action: ACTION;
  rule: DiscoveryRule;
};
